import AbstractModuleFactory from '@core/shared/module-factory';
import GetGeneralSettings from './use-cases/GetGeneralSettings';
import UpdateGeneralSettingsUseCase from './use-cases/UpdateGeneralSettings';
import { IGetGeneralSettings, IUpdateGeneralSettingsUseCase } from './interfaces';

export class SettingModuleFactory extends AbstractModuleFactory {
  createUpdateGeneralSettingsUseCase(): IUpdateGeneralSettingsUseCase {
    return this.ensureInstance('UpdateGeneralSettingsUseCase', () => new UpdateGeneralSettingsUseCase());
  }

  createGetGeneralSettingsUseCase(): IGetGeneralSettings {
    return this.ensureInstance('GetGeneralSettings', () => new GetGeneralSettings());
  }

  static new(): SettingModuleFactory {
    return new SettingModuleFactory();
  }
}

export default SettingModuleFactory.new();
